import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { initAnalytics, trackPageView } from "../lib/analytics";

/**
 * The Google tag in index.html records the first page load.
 * This hook records every later client-side route change.
 */
export function usePageTracking(): void {
  const { pathname, search } = useLocation();
  const isFirstRender = useRef(true);
  const lastPath = useRef<string | null>(null);

  useEffect(() => {
    initAnalytics();
  }, []);

  useEffect(() => {
    const path = `${pathname}${search}`;

    if (isFirstRender.current) {
      isFirstRender.current = false;
      lastPath.current = path;
      return;
    }

    if (lastPath.current === path) return;
    lastPath.current = path;

    const timer = window.setTimeout(() => trackPageView(path), 0);
    return () => window.clearTimeout(timer);
  }, [pathname, search]);
}
